import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';

import { CommentViewModule } from '@app/src/app/content-views/components/CommentView';
import { MgDirectivesModule } from '@app/src/app/directives';
import { InputsModule } from '@app/src/app/inputs';
import { PermissionsModule } from '@app/src/app/permissions';
import { MgPipesModule } from '@app/src/app/pipes';
import { MgSpinnerModule } from '@app/src/app/spinner';

import { CommentListViewComponent } from './CommentListView.component';

@NgModule({
  imports: [
    // Minga dependencies
    CommentViewModule,
    InputsModule,
    MgDirectivesModule,
    MgPipesModule,
    MgSpinnerModule,
    PermissionsModule,
    // External dependencies
    CommonModule,
    FlexLayoutModule,
  ],
  declarations: [CommentListViewComponent],
  exports: [CommentListViewComponent],
})
export class CommentListViewModule {}
